<template>
    <b-td style="width: 200px">
        <b-input-group id="date-picker-input-group">
            <b-form-input
                    :placeholder=placeholder
                    autocomplete="off"
                    id="example-input"
                    type="text"
                    v-model="val"
            ></b-form-input>
            <b-input-group-append>
                <b-form-datepicker
                        aria-controls="example-input"
                        button-only
                        class="custom-date-picker"
                        close-button
                        no-flip
                        offset="25"
                        reset-button
                        reset-value=''
                        today-button
                        v-model="value"
                ></b-form-datepicker>
            </b-input-group-append>
        </b-input-group>
    </b-td>
</template>

<script>
    import {tableList} from '../../utils/general/tableList';

    export default {
        name: 'TableFilterDatePicker',
        props: {
            placeholder: String,
            name: String,
            type: String
        },
        data() {
            return {
                tableList,
                value: '',
                val: ''
            };
        },
        updated() {
            if (this.value) {
                this.val = this.value ? this.tableList.formatedDate(this.tableList.filterMoment(this.value)) : null;
            } else {
                this.value = null;
                this.val = '';
            }
            this.$emit('method', this.name, this.value, 'fixedDate');
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
